import type { Locales } from "../../locales/translations";

// TODO: fetch from Strapi?
const localeConfigMap = {
	sv: {
		supportPhone: "08-509 285 00",
		supportPhoneHref: "tel:+46850928500",
		myPagesLink: "https://leabank.se/logga-in",
	},
	fi: {
		supportPhone: "",
		supportPhoneHref: "",
		myPagesLink: "",
	},
	nb: {
		supportPhone: "",
		supportPhoneHref: "",
		myPagesLink: "",
	},
} as const satisfies Record<Locales, unknown>;

export type SupportedLocale = keyof typeof localeConfigMap;

export const getLocaleConfig = (locale: SupportedLocale) =>
	localeConfigMap[locale];
